import { Component, inject, Input, OnInit } from '@angular/core';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import { IonLabel, ModalController } from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import {
  ModeControlData,
  ModeControlMultipleComponent,
} from '../../../../../../../../components/ecosystems/mode-control-multiple/mode-control-multiple.component';
import { P0003601SpeedChoiceComponent } from '../../../../P0003601/Component/p0003601-speed-choice/p0003601-speed-choice.component';
import { P0003601EnSavoirPlusComponent } from '../../../../P0003601/EnSavoirPlus/p0003601-en-savoir-plus/p0003601-en-savoir-plus.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { P00058SpeedChoiceComponent } from '../../../Component/p00058-speed-choice/p00058-speed-choice.component';
import { P00058AutoChoiceComponent } from '../../../Component/p00058-auto-choice/p00058-auto-choice.component';

@Component({
  selector: 'app-p00058-filtration-controle',
  templateUrl: './p00058-filtration-controle.component.html',
  styleUrls: ['./p00058-filtration-controle.component.scss'],
  imports: [IonLabel, ModeControlMultipleComponent, TranslatePipe],
})
export class P00058FiltrationControleComponent implements OnInit {
  private modalController: ModalController = inject(ModalController);
  private translateService: TranslateService = inject(TranslateService);

  @Input() productClass: IProduct | null = null;
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  buttons: ModeControlData[] = [
    {
      ref: 1,
      label: this.translateService.instant(
        'P00058.card.state.filtration.status.manuel',
      ),
      icon: '',
      color: 'color-green',
      onPress: () => {
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PompeVS_Controle,
          'pvCModeFonctionnement',
          1,
        );
        this.actionStack!.commit();

        this.openManual().finally(() => {});
      },
    },
    {
      ref: 2,
      label: this.translateService.instant(
        'P00058.card.state.filtration.status.auto',
      ),
      icon: '',
      color: 'color-orange',
      onPress: () => {
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PompeVS_Controle,
          'pvCModeFonctionnement',
          2,
        );
        this.actionStack!.commit();

        this.openAuto().finally(() => {});
      },
    },
    {
      ref: 0,
      label: this.translateService.instant(
        'P00058.card.state.filtration.status.off',
      ),
      icon: 'fa-kit fa-picto-off',
      color: 'color-red',
    },
    {
      ref: 3,
      label: this.translateService.instant(
        'P00058.card.state.filtration.status.ecremage',
      ),
      icon: 'fa-kit fa-picto-ecremage',
      color: 'color-orange',
    },
  ];

  getButtons(): ModeControlData[] {
    const vitesseManuelle =
      this.actionStack!.getValue('pvCProgrammeManuel') ?? 0;
    const programmeFiltrationAuto =
      this.actionStack!.getValue('pvCProgrammeAuto') ?? 0;

    let res = 'fa-kit fa-vs-v1';

    if (vitesseManuelle === 0) {
      res = 'fa-kit fa-vs-v1';
    } else if (vitesseManuelle === 1) {
      res = 'fa-kit fa-vs-v2';
    } else if (vitesseManuelle === 2) {
      res = 'fa-kit fa-vs-max';
    }

    this.buttons[0].icon = res;

    let res2 = 'fa-kit fa-vs-v1';

    if (programmeFiltrationAuto === 0) {
      res2 = 'fa-kit fa-picto-horlogeete';
    } else if (programmeFiltrationAuto === 1) {
      res2 = 'fa-kit fa-picto-horlogehiver';
    } else if (programmeFiltrationAuto === 2) {
      res2 = 'fa-kit fa-picto-horloge72h';
    } else if (programmeFiltrationAuto === 3) {
      res2 = 'fa-kit fa-vs-v2';
    }

    this.buttons[1].icon = res2;

    console.log(this.buttons, vitesseManuelle, programmeFiltrationAuto);

    return this.buttons;
  }

  async openManual() {
    const modal = await this.modalController.create({
      component: P00058SpeedChoiceComponent,
      componentProps: {
        value: this.actionStack!.getValue('pvCProgrammeManuel') ?? 0,
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Controle,
        'pvCProgrammeManuel',
        data.value,
      );
      this.actionStack!.commit();
    }
  }

  async openAuto() {
    const modal = await this.modalController.create({
      component: P00058AutoChoiceComponent,
      componentProps: {
        value: this.actionStack!.getValue('pvCProgrammeAuto') ?? 0,
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Controle,
        'pvCProgrammeAuto',
        data.value,
      );
      this.actionStack!.commit();
    }
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
}
